import Swiper, { Pagination, Navigation } from 'swiper';
import { EVENT_APPLY_FILTER_STRING, EVENT_RESET_FILTER } from '../../constants';

const { eventBus } = window.specialtyApp;

Swiper.use([Pagination, Navigation]);

export function initCatalogLabSlider() {
    const sliderContainerSelector = '.js-lab-filter-slider .swiper-container';
    const paginationSelector = '.js-lab-filter-slider .swiper-pagination';
    const nextElSelector = '.js-lab-filter-slider .js-lab-next-slide';
    const prevElSelector = '.js-lab-filter-slider .js-lab-prev-slide';
    const sliderContainer = $(sliderContainerSelector);
    const slides = $('.swiper-slide', sliderContainer);
    // const sliderInitialized = false;

    if (slides.length < 2) {
        [nextElSelector, prevElSelector].forEach((sel) => {
            $(sel).remove();
        });
        return;
    }

    const container = document.querySelector(sliderContainerSelector);

    if (container) {
        const swiperInstance = new Swiper(container, {
            loop: true,
            effect: 'fade',
            spaceBetween: 16,
            navigation: {
                nextEl: nextElSelector,
                prevEl: prevElSelector,
            },
            pagination: {
                el: paginationSelector,
                clickable: true,
            },
        });

        swiperInstance.on('slideChangeTransitionEnd', (swiper) => {
            const requestFilterQuery = $(swiper.slides[swiper.activeIndex]).data('filterQuery');
            eventBus.$emit(requestFilterQuery ? EVENT_APPLY_FILTER_STRING : EVENT_RESET_FILTER, requestFilterQuery);
        });
        $(container).data('swiperInstance', swiperInstance);
    }
}
